import { Box, Drawer } from "@mui/material";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

import { LOCAL_STORAGE_KEY_MENU_FIXED } from "@helpers/constants";

import FloatingAssistant from "../../../assistant/components/FloatingAssistant";
import ErrorBoundary from "../ErrorBoundary";
import { GetStarted } from "../GetStarted/GetStarted";
import { GetStartedContext } from "../GetStarted/GetStartedContext";
import Header from "../Header";
import SideNavigation from "../SideNavigation/SideNavigation";
import Terms from "../Terms";
import styles from "./AppLayout.module.scss";

function AppLayout(props: { children: React.ReactNode }) {
  const { isDrawerOpen, toggleDrawer } = useContext(GetStartedContext);

  const [isMenuFixed, setIsMenuFixed] = useState(
    localStorage.getItem(LOCAL_STORAGE_KEY_MENU_FIXED) === "1",
  );
  const menu = useRef<HTMLElement>(null);
  const handleToggleMenu = useCallback(() => {
    if (isMenuFixed) {
      localStorage.setItem(LOCAL_STORAGE_KEY_MENU_FIXED, "");
      setIsMenuFixed(false);
    } else {
      localStorage.setItem(LOCAL_STORAGE_KEY_MENU_FIXED, "1");
      setIsMenuFixed(true);
    }
  }, [isMenuFixed]);

  const handleKeyUp = useCallback(() => {
    const currentMenu = menu.current;
    if (
      !isMenuFixed &&
      currentMenu &&
      currentMenu.contains(document.activeElement)
    ) {
      handleToggleMenu();
    }
  }, [isMenuFixed, handleToggleMenu]);

  useEffect(() => {
    const currentMenu = menu.current;
    if (currentMenu) {
      window.addEventListener("keyup", handleKeyUp);
      return () => window.removeEventListener("keyup", handleKeyUp);
    }
  }, [handleKeyUp]);

  return (
    <Box className={`${styles.app} ${isMenuFixed ? styles.menuFixed : ""}`}>
      <Header />
      <SideNavigation
        handleToggleMenu={handleToggleMenu}
        isMenuFixed={isMenuFixed}
        ref={menu}
      />
      <main>
        <ErrorBoundary>
          {props.children}
          <Terms />
        </ErrorBoundary>
      </main>
      <Drawer open={isDrawerOpen} onClose={() => toggleDrawer()} anchor="right">
        <GetStarted />
      </Drawer>
      <FloatingAssistant />
    </Box>
  );
}

export default AppLayout;
